import React from 'react';
import { Icon } from 'semantic-ui-react';
import Proptypes from 'prop-types';
import FormSection from '../../../../components/FormComponents/FormSection';
import PropertyRow from '../PropertyRow';

import damagedPropertiesIcon from '../../../../img/formSectionIcons/damagedProperties.svg';
import useStyles from './makeStyles';

const DamagedProperties = ({
  formProps: { errors, clearError },
  i18n,
  damagedProperties,
  handleDamagedPropertyChange,
  handleDamagedPropertyDelete,
  addNewProperty,
}) => {
  const classes = useStyles();

  return (
    <FormSection title="propertyClaim.accInfo.damagedProperties" icon={damagedPropertiesIcon}>
      {damagedProperties.map((damagedProperty, index) => (
        <PropertyRow
          key={damagedProperty.id}
          data={damagedProperty}
          onDataChange={(newValue) => {
            handleDamagedPropertyChange(damagedProperty.id, newValue);
          }}
          subTitleNum={index + 1}
          isDeletable={index > 0}
          handleDelete={() => {
            handleDamagedPropertyDelete(damagedProperty.id);
          }}
          errors={errors}
          clearError={clearError}
        />
      ))}
      <div className={classes.plusIcon} onClick={() => addNewProperty()} role="presentation">
        <Icon name="plus circle" className={classes.addIcon} />
        <p>{i18n.t('propertyClaim.accInfo.addProperty')}</p>
      </div>
    </FormSection>
  );
};

DamagedProperties.propTypes = {
  formProps: Proptypes.shape({
    errors: Proptypes.shape({}),
    clearError: Proptypes.func,
  }).isRequired,
  damagedProperties: Proptypes.arrayOf(Proptypes.shape({})),
  addNewProperty: Proptypes.func.isRequired,
  i18n: Proptypes.shape({
    t: Proptypes.func,
  }).isRequired,
  handleDamagedPropertyChange: Proptypes.func.isRequired,
  handleDamagedPropertyDelete: Proptypes.func.isRequired,
};

DamagedProperties.defaultProps = {
  damagedProperties: [],
};

export default DamagedProperties;
